import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

let abortControllerFetchProductions = null;

export const fetchProducts = createAsyncThunk(
  'get/products/v3/products',
  async (_, { dispatch }) => {
    try {
      if (abortControllerFetchProductions) {
        abortControllerFetchProductions.abort();
      }
      abortControllerFetchProductions = new AbortController();

      const res = await callApi({
        endpoint: 'products/v3/products',
        method: 'get',
        signal: abortControllerFetchProductions.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
